import externalApi from '@/apis/external'

const getDynamicData = async ({ commit }, url) => {
  try {
    const dynamicData = await externalApi.getAffiliateData(url)
    let dynamicDataParsed = {}
    dynamicDataParsed.menu = dynamicData.data.menu.slice(0, 10)
    dynamicDataParsed.header = {}
    dynamicDataParsed.footer = {}

    if (dynamicData.data.menu.length % 10 > 1) {
      dynamicDataParsed.moreMenuItems = dynamicData.data.menu.slice(10, dynamicData.data.menu.length)
    }

    dynamicDataParsed.header.logo = dynamicData.data.branding.header.logo
    dynamicDataParsed.header.backgroundColor = dynamicData.data.branding.header.primary_color
    dynamicDataParsed.header.color = dynamicData.data.branding.header.secondary_color

    dynamicDataParsed.footer.footerMsg = dynamicData.data.branding.footer.footer_message
    dynamicDataParsed.footer.backgroundColor = dynamicData.data.branding.footer.primary_color
    dynamicDataParsed.footer.color = dynamicData.data.branding.footer.secondary_color
    dynamicDataParsed.footer.menu = dynamicData.data.branding.footer.footer_menu


    commit('SET_ISLOADING', false)
    commit('SET_DYNAMIC_DATA', dynamicDataParsed)
  } catch (error) {
    throw new Error(error)
  }
}

export default {
  getDynamicData
}
